<div class="py-4 question-number-pad-left">
    <div class="row justify-content-md-center">
        <div class="col-7">
            <label class="form-label">
                <h2 class="subtitle">
                    @if (subquestions().length) {
                        <span class="question-number">
                            {{question()?.sequence_number}}.{{subquestions()[0].sub_sequence_number}}
                        </span>
                        {{subquestions()[0].content}}
                    }
                </h2>
            </label>
        </div>
        @if (!readonly() && !hideExplainDiff()) {
        <div class="col-5">
        </div>
        }
        <div class="col-7">
            <p>
                {{question()?.helptext}}
            </p>
            @for (subquestion of subquestions(); track subquestion.id; let first = $first; let i = $index) {
            @if (!first) {
            <label class="form-label mt-2">
                <span class="question-number">
                    {{question()?.sequence_number}}.{{subquestion.sub_sequence_number}}
                </span>
                {{subquestion.content}}
            </label>
            }
            @if (readonly()) {
            <div class="card">
                <div class="card-body">
                    {{answers()[subquestion.id] || '-'}}
                </div>
            </div>
            }
            @else {
            <textarea class="form-control" [placeholder]="first ? subquestion.content : ''"
                (keyup)="updateAnswer(subquestion.id, $event)" (change)="updateAnswer(subquestion.id, $event)"
                [value]="answers()[subquestion.id]"></textarea>
            }
            }
            @if (!hideExplainDiff()) {
            @if (readonly()) {
            <div class="card text-bg-light mt-4">
                <div class="card-header">
                    Toelichting bij wijzigingen
                </div>
                <div class="card-body">
                    {{question()?.explain_diff || '-'}}
                </div>
            </div>
            }
            @else {
            <label class="form-label mt-2">
                Toelichting bij wijzigingen
            </label>
            <textarea class="form-control" (keyup)="updateExplainDiff($event)" (change)="updateExplainDiff($event)"
                [readOnly]="readonly()" [value]="explainDiff()"></textarea>
            }
            }
        </div>
        @if (!readonly() && !hideExplainDiff()) {
        <div class="col-5">
            <fgai-history-answer (copyQuestion)="copyQuestion($event)" [questionnaire]="questionnaire()"
                [question]="question()"></fgai-history-answer>
        </div>
        }
    </div>
</div>
